<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-tabs
            [items]="tabs"
            [(selectedIndex)]="selectedTabIndex"
            (onItemClick)="onTabClick($event)"
            class="mb-3"
        ></dx-tabs>
        <dx-data-grid
            id="durationSettingsGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'duration-settings-grid', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowDblClick)="onRowDblClick($event)"
            (onInitNewRow)="onInitNewRow($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-editing
                [mode]="'row'"
                [allowUpdating]="true"
                [allowAdding]="true"
                [allowDeleting]="true"
                [useIcons]="true"
            >
            </dxo-editing>

            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">{{ selectedTabName }} SLA</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item>
                    <dx-button
                        class="ms-sm-2"
                        text="Add New"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addNew()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('from')" [caption]="fromCaption" dataType="number" [minWidth]="100" alignment="left">
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('to')" [caption]="toCaption" dataType="number" [minWidth]="100" alignment="left"></dxi-column>

            <dxi-column [dataField]="gridFieldName('name')" caption="Status Name" [minWidth]="150">
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column [dataField]="gridFieldName('color')" caption="Color" [minWidth]="100" cellTemplate="colorCellTemplate" editCellTemplate="colorEditCellTemplate">
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <div *dxTemplate="let data of 'colorCellTemplate'">
                <app-color-swatch [color]="getColor(data.value)" [text]="data.value"></app-color-swatch>
            </div>

            <div *dxTemplate="let data of 'colorEditCellTemplate'">
                <app-color-select-box
                    [value]="data.value"
                    (valueChange)="data.setValue($event)"
                    [readOnly]="false"
                ></app-color-select-box>
            </div>
        </dx-data-grid>
    </div>
</div>
